<template>
  <Layout>
    <div class="p-2 text-xl text-gray-900">
      <h3 class="pl-2 font-bold">Vytvoření Nové Rezervace</h3>
    </div>

    <form method="POST" :action="$route('storeReservationAdmin')">
      <div class="flex justify-center">
        <div class="pt-10">
          <label
            class="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
            for="type"
          >
            Počet Lidí
          </label>
          <input
            id="pocetLidi"
            type="text"
            name="pocetLidi"
            class="block w-48 px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-50 border border-gray-200 rounded focus:outline-none focus:bg-white"
            placeholder="Počet Lidí"
          />

          <label
            class="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
            for="type"
          >
            Typ
          </label>
          <select
            id="type"
            name="type"
            class="block w-48 px-4 py-3 pr-8 leading-tight text-gray-700 bg-gray-50 border border-gray-200 rounded focus:outline-none focus:bg-white"
          >
            <option value="rez">Rezervace</option>
            <option value="ob">Obsazeno</option>
          </select>

          <label
            class="block pt-10 mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
            for="type"
          >
            Jméno
          </label>
          <input
            id="name"
            type="text"
            name="name"
            class="block w-48 px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-50 border border-gray-200 rounded focus:outline-none focus:bg-white"
            placeholder="Jméno"
          />

          <label
            class="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
            for="type"
          >
            Email
          </label>
          <input
            id="email"
            type="email"
            name="email"
            class="block w-48 px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-50 border border-gray-200 rounded focus:outline-none focus:bg-white"
            placeholder="Email"
          />

          <label
            class="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
            for="type"
          >
            Mobil
          </label>
          <input
            id="mobile"
            type="text"
            name="mobile"
            class="block w-48 px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-50 border border-gray-200 rounded focus:outline-none focus:bg-white"
            placeholder="Mobil"
          />

          <div class="flex pt-6">
            <label
              class="mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
              for="confirmReservation"
            >
              Automaticky potvrdit rezervaci
            </label>
            <input
              class="ml-4"
              id="confirmReservation"
              name="confirmReservation"
              type="checkbox"
              checked
            />
          </div>

          <button type="submit" class="p-2 mt-8 text-white bg-blue-600 rounded">
            Vytvořit rezervaci
          </button>
        </div>
        <div class="pt-16">
          <DatePicker></DatePicker>
        </div>
      </div>
    </form>
  </Layout>
</template>

<script>
import Layout from "../../../Layouts/admin.vue";
import DatePicker from "../../../components/DatePicker.vue";
import Inertia from '@inertiajs/inertia';
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Layout,
    DatePicker,
    Link
  },

  methods: {
    onSubmit() {
        Inertia.post($route('storeReservationAdmin'))

        
    },
  },
};
</script>
